module.exports = __webpack_public_path__ + "img/0Q3A7263_L_WoodMatted.66dfad1e.jpg";